import { RootState } from '@state/ducks';
import { ProductDetailAction, SET_SELECTED_VARIANT } from '@state/ducks/productdetail/productdetail.reducer';
import SearchableSelect from '@stories/Components/Forms/SearchableSelect/SearchableSelect';
import React, { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export interface ProductVariantSelectorProps {
  showBottomBorder?: boolean;
}

const ProductVariantSelector: FunctionComponent<ProductVariantSelectorProps> = ({ showBottomBorder = true }) => {
  const { variants, translations } = useSelector((x: RootState) => x.productDetail);
  const selectedVariantAgilityId = useSelector((x: RootState) => x.productDetail.selectedVariantAgilityId);
  const dispatch = useDispatch();

  const handleItemClick = (agilityId: number): void => {
    dispatch<ProductDetailAction>({
      type: SET_SELECTED_VARIANT,
      payload: agilityId,
    });
  };

  if (variants.length === 0) {
    return null;
  }

  return (
    <SearchableSelect
      noResultsText={translations['custom.productdetail.noresults']}
      placeholder={translations['custom.productdetail.selectvariantplaceholder']}
      selectAValueText={translations['custom.productdetail.selectvariantlabel']}
      selectedValueText={translations['custom.productdetail.selectedvariant']}
      onChange={(e) => handleItemClick(parseInt(e, 10))}
      options={variants.map((x) => ({ text: x.name, value: `${x.agilityId}` }))}
      showSearch={variants.length > 4}
      selectedValue={selectedVariantAgilityId ? `${selectedVariantAgilityId}` : undefined}
      showBottomBorder={showBottomBorder}
    />
  );
};

export default ProductVariantSelector;
